import { css } from "@emotion/react";

const FooterContentLayoutStyle = {
  bannerImg: css`
    width: 100%;
    height: 100%;
    object-fit: cover;
  `,

  wrapper: css`
    padding: 30px 0;
    height: 730px;

    display: flex;
  `,

  mainContent: css`
    flex: 1;

    border: 1px solid #cccccc;

    padding: 20px;

    overflow-y: auto;
  `,
};
export default FooterContentLayoutStyle;
